import { useContext } from 'react';
import Modal from '@/srp/Modal';
import Tag from '@/srp/Tag';
import {
  AdditionalRequirements,
  CleanVehicleTaxSavings,
  IncomeRequirements,
  VehicleRequirements
} from '@/vdp/Modals/EvTaxCreditModal/ModalSections';
import ModalContext from '~/context/srp/ModalContext';
import { Content } from './EVTaxCreditModal.styles';

export default function EvTaxCreditModal() {
  const { isEVTaxCreditModalOpen, setEVTaxCreditModalOpen } =
    useContext(ModalContext);

  const onClose = () => {
    setEVTaxCreditModalOpen(false);
  };

  return (
    <Modal
      headerText="EV Tax Credit"
      open={isEVTaxCreditModalOpen}
      onToggle={onClose}
      whiteBg
    >
      <Content data-qa="ev-tax-modal-card">
        <Tag
          bigTag
          blueText
          tag="ev"
          text="Clean Vehicle Tax Credit"
          data-qa="ev-credit-tag"
        />
        <CleanVehicleTaxSavings />
        <div className="w-full border-t border-grey-2" />
        <IncomeRequirements />
        <AdditionalRequirements />
        <VehicleRequirements />
      </Content>
    </Modal>
  );
}
